import { useCallback, useEffect, useState } from "react";
import CaseTable from "./CaseTable";
import { Link } from "react-router-dom";
import "./case_study.css";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";

const caseEditPath = "edit-case-study";
const adminCaseListEndpoint = ApiEndpoints.newCase.adminCaseList;
const caseDeleteEndpoint = ApiEndpoints.newCase.adminCaseDelete;
const tableHeader = ["Rank", "Title", "Slug"];
const tbody = ["rank", "title", "slug"];

export default function CaseStudyListAdmin() {
  const [data, setData] = useState([]);

  const dataFetch = useCallback(
    async () => {
      try {
        const response = await ApiRequest("GET", adminCaseListEndpoint);
        const result = response.newcasestudys;
        setData(result);
      } catch (error) {
        console.log(error);
      }
    }, [adminCaseListEndpoint])

  useEffect(() => {
    dataFetch();
  }, [dataFetch]);

  const handleDelete = async (newcasestudy_id) => {
    const payload = { newcasestudy_id };
    try {
      await ApiRequest("POST", caseDeleteEndpoint, payload);
      dataFetch();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="header-add-category">
        <h5>Case Study</h5>
      </div>
      <div className="add-casestudy-section">
        <Link className="default-btn" to="/admin/add-case-study">
          Add Case Study
        </Link>
        <CaseTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={caseEditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  )
}
